export const PHASE_COLORS = {
  "PGS 0": "#228E40",
  "PGS 1": "#B57801",
  "PGS 2": "#4BB34B",
  "PGS 3": "#027C02",
  "PGS 4": "#FF63FF",
  "PGS 5": "#889400",
  "PGS 6": "#E38901",
  "PGS 7": "#A2A2A2",
  "PGS 8": "#CC5D2D",
  "PGS 9": "#D4AF37",
};
